import * as React from "react";
import { useState } from "react";
import classnames from "classnames";

import envConfig from "../../../../utils/env-config";
import { BaseModal } from "../../../atoms/base-modal";
import { ProcedureEntity } from "../../../../application/domain/procedures/procedure-entity";
import {
  CsvOutputValueOption,
  SelectableAppMeta,
} from "./csv-output-value-option";
import { CsvOutputValueExpOption } from "./csv-output-value-exp-option";
import { CSVEncoding } from "../../../../application/domain/file-encoding";

interface DownloadCsvModalProps {
  isActive: boolean;
  page: number;
  selectedProcedure: ProcedureEntity;
  selectable: SelectableAppMeta;
  onDownloadCsv: (
    csvEncoding: CSVEncoding,
    includeTenantProcessResult: boolean,
    requireSelectableRawValue: boolean,
    offset?: number,
  ) => Promise<void>;
  onClose: () => void;
}

export const DownloadCsvModal: React.FC<DownloadCsvModalProps> = ({
  isActive,
  selectedProcedure,
  selectable,
  onDownloadCsv,
  onClose,
}) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [encoding, setEncoding] = useState<CSVEncoding>(
    "Shift_JIS" as CSVEncoding,
  );
  const [requireSelectableRawValue, setRequireSelectableRawValue] =
    useState(false);
  const [includeTenantProcessResult, setIncludeTenantProcessResult] =
    useState(false);

  const isEnablePagination: boolean = envConfig.matchEnv({
    local: () => false,
    dev: () => selectedProcedure.id === "3354196740354359797", // takeda dev city-graffer/safenet-crisis
    staging: () => selectedProcedure.id === "7504995384587210690", // city-graffer/safenet-crisis
    staging_sandbox: () => false,
    production: () =>
      selectedProcedure.id === "1822031245636620167" ||
      selectedProcedure.id === "4718398451267421080", // city-kobe/市県民税所得・課税（非課税）証明書交付申請,
    production_sandbox: () => false,
  });
  const [offset, setOffset] = useState<number>(1);
  return (
    <BaseModal isActive={isActive} title="CSV出力" onClose={onClose}>
      <section className="modal-card-body">
        <section className="column mb-5">
          <CsvOutputValueOption
            procedure={selectedProcedure}
            selectable={selectable}
            includeTenantProcessResult={includeTenantProcessResult}
            onCheckIncludeTenantProcessResult={setIncludeTenantProcessResult}
            tenantProcessResultSetting={
              selectedProcedure.published?.template.tenantProcessResultSetting
            }
          />
        </section>
        {isEnablePagination && (
          <section className="column mb-5">
            <div className="field" style={{ padding: "2px 0" }}>
              <label className="label">csv出力ページ</label>
              <input
                type="number"
                className="input"
                defaultValue={offset.toString()}
                onChange={(e) => {
                  e.stopPropagation();
                  setOffset(parseInt(e.target.value, 10));
                }}
              />
            </div>
          </section>
        )}
        <section className="column mb-5">
          <CsvOutputValueExpOption
            encoding={encoding}
            requireSelectableRawValue={requireSelectableRawValue}
            onChangeCSVEncoding={setEncoding}
            onChangeRequireSelectableRawValue={setRequireSelectableRawValue}
          />
        </section>
      </section>
      <footer className="modal-card-foot">
        <button className="button is-failure is-fullwidth" onClick={onClose}>
          キャンセル
        </button>
        <button
          disabled={isSubmitting || offset < 1}
          className={classnames("button is-info is-fullwidth", {
            "is-loading": isSubmitting,
          })}
          onClick={async (e) => {
            e.preventDefault();
            setIsSubmitting(true);
            await onDownloadCsv(
              encoding,
              includeTenantProcessResult,
              requireSelectableRawValue,
              offset,
            );
            setIsSubmitting(false);
            onClose();
          }}
          data-for-rpa-id={"download-csv"}
        >
          出力する
        </button>
      </footer>
    </BaseModal>
  );
};
